import React, { useRef } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Contact from "./components/Contact";
import Info from "./components/Info";
import AboutUs from "./components/AboutUs";
import Values from "./components/Values";
import Services from "./components/Services";
import Safety from "./components/Safety";
import TeamMembers from "./components/TeamMembers";
import CustomerFeedback from "./components/CustomerFeedback";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";
import ScrollToTop from "./components/ScrollToTop";
import PrivacyPolicy from "./components/PrivacyPolicy";

import Login from "./components/Login";
import Dashboard from "./pages/Dashboard";
import PrivateRoute from "./components/PrivateRoute";

import "./styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

/* ============================= */
/* Layout Wrapper */
/* ============================= */

function Layout({ children, refs }) {
  const location = useLocation();

  // Hide navbar/footer on auth pages
  const hideLayout =
    location.pathname === "/login" ||
    location.pathname === "/dashboard";

  return (
    <div className="App">

      {!hideLayout && (
        <Navbar
          navbarRef={refs.navbarRef}
          infoRef={refs.infoRef}
          servicesRef={refs.servicesRef}
          safetyRef={refs.safetyRef}
          contactRef={refs.contactRef}
        />
      )}

      {children}

      {!hideLayout && (
        <>
          <Footer />
          <Chatbot />
          <ScrollToTop />
        </>
      )}
    </div>
  );
}

/* ============================= */
/* MAIN APP */
/* ============================= */

function App() {

  // ===== REFS (KEEPING YOUR OLD WORKING SETUP) =====
  const navbarRef = useRef(null);
  const infoRef = useRef(null);
  const servicesRef = useRef(null);
  const safetyRef = useRef(null);
  const contactRef = useRef(null);

  const refs = {
    navbarRef,
    infoRef,
    servicesRef,
    safetyRef,
    contactRef,
  };

  return (
    <Router>

      <Layout refs={refs}>

        <Routes>

          {/* ================= HOME ================= */}

          <Route
            path="/"
            element={
              <>
                <div ref={navbarRef}>
                  <Hero />
                </div>

                <div ref={infoRef}>
                  <Info />
                </div>

                <Values />

                <AboutUs />

                <div ref={servicesRef}>
                  <Services />
                </div>

                <div ref={contactRef}>
                  <Contact />
                </div>

                <div ref={safetyRef}>
                  <Safety />
                </div>

                <TeamMembers />

                <CustomerFeedback />
              </>
            }
          />

          {/* ================= PAGES ================= */}

          <Route path="/about" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          {/* ================= AUTH ================= */}

          <Route path="/login" element={<Login />} />

          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />

        </Routes>

      </Layout>

    </Router>
  );
}

export default App;
